import styled from '@emotion/styled';
import { css } from 'twin.macro';
export const statusColorMap = {
    complete: '#4CAF50', // green
    inProgress: '#FFC107', // yellow
    error: '#F44336', // red
    default: '#9E9E9E', // gray
};
export const ParticipantsContainer = styled.div`
    padding: 0.5rem;
    .userInRoom {
        box-sizing: border-box;
        width: 80%;
    }
`;

export const formPaginationContainerStyles = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    padding: 1rem;
    border: 1px solid #eee;
    background-color: #f5f5f5;
`;

export const staticPreviewContainerStyles = css`
    position: relative;
    display: flex;
`;

export const getFormContainerStyles = (hasMultiplePages) => css`
    margin-left: ${hasMultiplePages ? '256px' : '0'};
    flex: 1;
    min-width: 500px;
`;

export const cardStyles = css`
    min-height: 150px;
    height: fit-content;
`;

export const formPageStyles = css`
    margin-bottom: 5px;
    padding: 1rem 0.5rem 1rem 1rem;
    overflow-wrap: break-word;
    transition:
        opacity 300ms ease,
        transform 300ms ease;
    opacity: 0;
    transform: translateX(20px);
    position: absolute;
    width: 100%;

    &.visible {
        opacity: 1;
        transform: translateX(0);
        position: relative;
    }

    &.hidden {
        pointer-events: none;
        height: 0;
    }
`;

export const validationErrorStyles = css`
    color: #dc3545;
    text-align: center;
    margin: 1rem 0;
`;

export const stepperContainerStyles = css`
    position: absolute;
    left: 0;
    top: 0;
    width: 256px;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto;
    border-right: 1px solid #eee;
    background: #f9f9f9;
    padding: 1rem 0.25rem;
    display: flex;
    flex-direction: column;
    z-index: 1;
`;

export const stepButtonStyles = css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    margin-bottom: 1rem;
    width: 100%;
    border-radius: 50px;
    font-size: 1.5rem;
    &:hover {
        transform: none;
        text-decoration: underline;
        text-underline-offset: 0.25rem;
    }
`;

export const stepNumberStyles = (status) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    background-color: ${statusColorMap[status] || '#ccc'};
    flex-shrink: 0;
`;

export const stepLabelStyles = css`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis !important;
    line-height: 1.2;
    max-height: calc(1.2em * 3);
    text-align: left;
`;
